import type { ReactNode } from 'react';
import { Icon } from './Icon';

interface ModalProps { title: string; kicker?: string; children: ReactNode; onClose: () => void }

export function Modal({ title, kicker, children, onClose }: ModalProps) {
  return <div className="modal-backdrop" role="presentation">
    <section className="modal-sheet" role="dialog" aria-modal="true" aria-label={title}>
      <header className="modal-header">
        <div>{kicker ? <span className="micro-label">{kicker}</span> : null}<h2>{title}</h2></div>
        <button className="icon-button" type="button" aria-label="關閉" onClick={onClose}><Icon name="close" /></button>
      </header>
      {children}
    </section>
  </div>;
}
